import { fromRef } from '../observable/fromRef';
export function createObjectSnapshotChanges(query) {
    return function snapshotChanges() {
        return fromRef(query, 'value');
    };
}
//# sourceMappingURL=snapshot-changes.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angularfire2/database/object/snapshot-changes.js
// module id = 1396
// module chunks = 21